//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

/**
 * Calculates the Jaccard similarity between two strings.
 * The Jaccard similarity is defined as the size of the intersection divided by the size of the union of two sets.
 * @param string1 - The first string to compare.
 * @param string2 - The second string to compare.
 * @returns A number between 0 and 1 representing the Jaccard similarity.
 */
export const jaccardSimilarity = (string1: string, string2: string): number => {
  const tokenize = (str: string): Set<string> =>
    new Set(str.split(/\s+/).filter(Boolean));

  const set1: Set<string> = tokenize(string1);
  const set2: Set<string> = tokenize(string2);

  if (set1.size === 0 && set2.size === 0) {
    return 1.0;
  }

  const intersection = new Set<string>(
    Array.from(set1).filter((word) => set2.has(word)),
  );

  const union = new Set<string>([...Array.from(set1), ...Array.from(set2)]);

  return intersection.size / union.size;
};
